'use strict';

export default class MemberListCtrl {
  constructor($stateParams, $location, LoaderSvc, GroupSvc, GroupAuthSvc,
    MemberSvc, moment, FileSaveSvc) {
    LoaderSvc.start('Loading Members...');

    var that = this;
    var ctxId = $stateParams.ctxId;
    var groupId = $stateParams.groupId || ctxId;
    that.ctxId = ctxId;
    this.groupId = groupId; // set for member urls

    // authorization
    GroupAuthSvc.validatePermission(groupId, 'member', 'I');

    // default filter
    this.order = 'lname';
    if(Object.keys($location.search()).length === 0) {
      $location.search({isActive: 'true'}); // string required for url
    }

    // pass tz as queryString param to server for active query
    var tz = moment().utcOffset();
    // tz = '-720' // option for testing '+720' '-720'

    MemberSvc.query({groupId, tz}).$promise
      .then(function(data) {
        that.data = data;
        LoaderSvc.stop();
      })
      .catch(function() { LoaderSvc.stopError('Error loading members'); });

    this.download = function() {
      var fields = [{label: 'Member', value: 'displayName'},
        {label: 'Email', value: 'email'},
        {label: 'Member Type', value: 'type'},
        {label: 'Current Member?', value: 'isActive'}];
      FileSaveSvc.saveAsCsv({ data: this.data, fields}, 'Members', true);
    };
  }
}

MemberListCtrl.$inject = [
  '$stateParams',
  '$location',
  'LoaderSvc',
  'GroupSvc',
  'GroupAuthSvc',
  'MemberSvc',
  'moment',
  'FileSaveSvc'
];
